import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'pending.orders-amount',
    country: [
      'MX',
      'US',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'PH',
      'PL',
      'CZ',
      'AE',
      'EG'
    ]
  },
  {
    feature: 'pending-orders.pending-orders-pod-columns',
    country: ['FR', 'AE', 'EG']
  },
  {
    feature: 'pending-orders.scheduled-orders-pending-invoicing',
    excludes: { country: ['PH'] }
  },
  {
    feature: 'pending-orders.orders-pending-delivery',
    country: [
      'MX',
      'US',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'PH',
      'PL',
      'CZ',
      'AE',
      'EG'
    ]
  },
  {
    feature: 'pending-orders.unit-price-show-column',
    country: [
      'US',
      'MX',
      'CO',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'CZ',
      'EG',
      'AE'
    ]
  },
  {
    feature: 'pending-orders.subtotal-show-column',
    country: [
      'US',
      'MX',
      'CO',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'CZ',
      'AE'
    ]
  },
  {
    feature: 'pending-orders.unit-price',
    country: ['US', 'PL', 'CZ', 'AE']
  },
  {
    feature: 'pending-orders.unit-price-tax',
    country: [
      'MX',
      'CO',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'EG',
      'LV'
    ]
  },
  {
    feature: 'pending-orders.lifex',
    country: ['CZ', 'AE', 'LV']
  }
] as IAppConfiguration[];
